<template>
  <section class="card employment-section">
    <h4
      class="card-header collapse-bar"
      data-toggle="collapse"
      href="#employment-details"
      role="button"
      aria-expanded="false"
      aria-controls="employment-details"
      @click="animateIcon"
    >
      <!-- click action to collapse-->
      <transition name="fade" mode="out-in">
        <span class="collapse-icon" v-if="isCollapsed" key="closed">
          <font-awesome-icon :icon="['fas', 'angle-double-up']" />
        </span>
        <span class="collapse-icon" v-else key="open">
          <font-awesome-icon :icon="['fas', 'angle-double-down']" />
        </span>
      </transition>
      Employment
    </h4>
    <div id="employment-details" class="collapse">
      <div
        class="card-body employment"
        v-for="company in employmentData"
        :key="company.id"
      >
        <h5 class="card-title">
          <a :href="company.website" target="_blank">{{ company.company }}</a>
        </h5>
        <em class="text-muted employment-dates"
          >{{ company.startDate }} - {{ company.endDate }}</em
        >
        <blockquote class="lead text-right">
          {{ company.companyBlurb }}
        </blockquote>
        <div
          class="position"
          v-for="position in company.positions"
          :key="position.jobId"
        >
          <h6 class="title">{{ position.title }}</h6>
          <em class="text-muted employment-dates"
            >{{ position.startDate }} - {{ position.endDate }}</em
          >
          <ul>
            <li
              v-for="(highlight, highlightIndex) in position.highlights"
              :key="highlightIndex + '-highlight'"
            >
              {{ highlight }}
            </li>
          </ul>
        </div>
      </div>
      <a href="#employment-details" class="btn btn-link float-right">To Top</a>
    </div>
  </section>
</template>

<script>
//import _ from 'lodash'
import { animateIconMixin } from "./animateIconMixin";
import { getEmployment } from "../../db";
export default {
  name: "Employment",
  mixins: [animateIconMixin],
  data() {
    return {
      employmentData: [],
    };
  },
  mounted() {
    getEmployment().then(jobs => {
      this.employmentData = jobs;
    })
  },
};
</script>
